import React from 'react';
import { Users, Sparkles, Mail } from 'lucide-react';
export function PrivateDining() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-950" data-id="element-95">
      <div className="max-w-7xl mx-auto" data-id="element-96">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-97">
          {/* Image */}
          <div className="order-2 lg:order-1" data-id="element-98">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] border-2 border-slate-800" data-id="element-99">
              <img src="https://images.unsplash.com/photo-1564489563601-c53cfc451e93?w=1200&q=80" alt="Private dining room with elegant table setting" className="w-full h-full object-cover" data-id="element-100" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-101" />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2" data-id="element-102">
            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6" data-id="element-103">
              Private Dining & Events
            </h2>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed" data-id="element-104">
              Host your next celebration in our exclusive private dining room.
              Perfect for corporate events, intimate gatherings, and special
              occasions.
            </p>

            <div className="space-y-6 mb-10" data-id="element-105">
              <div className="flex items-start gap-4" data-id="element-106">
                <div className="bg-amber-500/20 p-3 rounded-lg border border-amber-500/30" data-id="element-107">
                  <Users className="w-6 h-6 text-amber-400" data-id="element-108" />
                </div>
                <div data-id="element-109">
                  <h3 className="text-xl font-semibold text-white mb-2" data-id="element-110">
                    Capacity
                  </h3>
                  <p className="text-gray-300" data-id="element-111">
                    Accommodates 12-30 guests with flexible seating arrangements
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-112">
                <div className="bg-amber-500/20 p-3 rounded-lg border border-amber-500/30" data-id="element-113">
                  <Sparkles className="w-6 h-6 text-amber-400" data-id="element-114" />
                </div>
                <div data-id="element-115">
                  <h3 className="text-xl font-semibold text-white mb-2" data-id="element-116">
                    Customizable Menus
                  </h3>
                  <p className="text-gray-300" data-id="element-117">
                    Work with our chef to create a personalized dining
                    experience
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-118">
                <div className="bg-amber-500/20 p-3 rounded-lg border border-amber-500/30" data-id="element-119">
                  <Mail className="w-6 h-6 text-amber-400" data-id="element-120" />
                </div>
                <div data-id="element-121">
                  <h3 className="text-xl font-semibold text-white mb-2" data-id="element-122">
                    Dedicated Service
                  </h3>
                  <p className="text-gray-300" data-id="element-123">
                    Private event coordinator and dedicated staff for your event
                  </p>
                </div>
              </div>
            </div>

            <a href="mailto:events@kumoizakaya.com" className="glow-button inline-block text-black px-10 py-5 rounded-full font-semibold" data-id="element-124">
              Book Your Event
            </a>
          </div>
        </div>
      </div>
    </section>;
}